export default __webpack_public_path__ + "fed907a752eeda6ea9204c945df38989.svg";